export const A51_PLACEMENT_TYPE = 'a51';

export const MOBWEB_PLACEMENT_MARKER = 'mobweb';

export const A51_LOADING_TIMEOUT_MS = 5000;

export const A51_STUB_PICTURE_PATH = 'illustrations/promo-placement-a51.webp';

export const ADFOX_SCRIPT_SRC = 'https://yandex.ru/ads/system/context.js';
